export default {
  loading: false
}
